module.exports = __webpack_public_path__ + "static/media/arrowLeft.41cf2c40.svg";